import { KeyRound, LogOut } from 'lucide-react';
import { useState } from 'react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useAuth } from '@/providers/auth-provider';
import { ChangePasswordDialog } from './change-password-dialog';

const initials = (s: string) => s.split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('');

export function UserMenu() {
  const { user, logout } = useAuth();
  const [changing, setChanging] = useState(false);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="rounded-lg" aria-label="Account">
            <Avatar className="size-7 rounded-lg"><AvatarFallback className="rounded-lg text-xs">{initials(user?.display_name || user?.email || '?')}</AvatarFallback></Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={8} className="min-w-56">
          <DropdownMenuLabel className="font-normal">
            <p className="truncate text-sm font-medium">{user?.display_name}</p>
            <p className="truncate text-xs text-muted-foreground">{user?.email}</p>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* Open after the menu closes, or the menu's focus return steals focus from the dialog. */}
          <DropdownMenuItem onSelect={() => setTimeout(() => setChanging(true), 0)}><KeyRound /> Change password</DropdownMenuItem>
          <DropdownMenuItem onClick={() => void logout()}><LogOut /> Sign out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangePasswordDialog open={changing} onOpenChange={setChanging} />
    </>
  );
}
